// PetInsuranceTopics.ts

export interface PetInsuranceTopicImage {
  src: string;
  alt: string;
}

export interface PetInsuranceTopic {
  id: string;
  title: string;
  titleImageUrl: string;
  items: string[]; // strings include **bold** markdown at the start
  images?: PetInsuranceTopicImage[]; // optional gallery for each topic
}

export const IMAGE_BASE = "insurance/images/PET-Images/";

// Shared gallery requested
export const PetGallery_v01: PetInsuranceTopicImage[] = [
  { src: IMAGE_BASE + "AdobeStock_74093746_DOG-Preview.jpeg", alt: "Happy dogs at the park" },
  { src: IMAGE_BASE + "AdobeStock_1320490477_CAT-Preview.jpeg", alt: "Travel Cat" },
  { src: IMAGE_BASE + "AdobeStock_118001293_DOG-Preview-FLIP.jpg", alt: "Puppy and owner" },
  { src: IMAGE_BASE + "AdobeStock_207653094_DOG-Bandage-Preview-FLIP.jpg", alt: "Doggy at the Vet - bandage" },
];

export const PetInsuranceTopics_v02: PetInsuranceTopic[] = [
  {
    id: "core-features",
    title: "Core Features",
    titleImageUrl: IMAGE_BASE + "AdobeStock_74093746_DOG-Preview.jpeg",
    items: [
      "**Accident & illness coverage:** injuries, poisonings, infections, cancer, diabetes, hip dysplasia, and more.",
      "**Diagnostics & imaging:** exams, X-rays, ultrasounds, MRIs, and lab work.",
      "**Hospitalization & surgery:** ER visits, overnight stays, anesthesia, and specialist referrals.",
      "**Prescription meds & treatments:** medications, chemo/radiation, IV fluids, and medical supplies.",
      "**Hereditary & chronic conditions:** covered if not pre-existing and after any waiting periods.",
      "**Dental (accident):** treatment for broken teeth and oral trauma caused by accidents.",
      "**Any licensed vet:** typically no networks—use your preferred clinic or specialist.",
      "**Customizable costs:** choose annual limit, deductible (annual/incident), and reimbursement % (often 70/80/90).",
      "**Claims & service:** online/photo claims, direct-deposit reimbursements, and fast turnaround; some offer 24/7 tele-vet."
    ],
    images: PetGallery_v01
  },
  {
    id: "optional-addons",
    title: "Optional Add-Ons",
    titleImageUrl: IMAGE_BASE + "AdobeStock_1320490477_CAT-Preview.jpeg",
    items: [
      "**Wellness/routine care:** annual exams, vaccines, flea/tick & heartworm meds, spay/neuter, microchipping, dental cleanings.",
      "**Rehab & alternative therapies:** physical therapy, acupuncture, chiropractic care, and hydrotherapy.",
      "**Behavioral therapy:** evaluations and treatment plans for anxiety, reactivity, or compulsive behaviors.",
      "**Travel & boarding:** trip cancellation due to pet illness, emergency boarding, lost-pet advertising and reward."
    ],
    images: PetGallery_v01
  },
  {
    id: "key-benefits",
    title: "Key Benefits",
    titleImageUrl: IMAGE_BASE + "AdobeStock_118001293_DOG-Preview-FLIP.jpg",
    items: [
      "**Protects your budget:** helps with large, unexpected vet bills and smooths costs over time.",
      "**Faster, better care decisions:** focus on treatment options instead of price tags during emergencies.",
      "**Freedom of choice:** keep your current vet and access specialists without network hurdles.",
      "**Supports lifelong health:** wellness add-ons encourage preventive care and early detection.",
      "**Covers long-tail risks:** many plans cover chronic and hereditary issues if enrolled before symptoms.",
      "**Multi-pet & loyalty perks:** discounts and advantages for starting early and staying covered.",
      "**Peace of mind:** reduces financial stress when the unexpected happens."
    ],
    images: PetGallery_v01
  },
  {
    id: "limits-exclusions",
    title: "Common Limits & Exclusions",
    titleImageUrl: IMAGE_BASE + "AdobeStock_207653094_DOG-Bandage-Preview-FLIP.jpg",
    items: [
      "**Pre-existing conditions:** generally excluded (some curable conditions may be eligible after a symptom-free period).",
      "**Waiting periods:** apply after enrollment and may differ for accidents, illness, or orthopedic issues.",
      "**Non-covered procedures:** elective/cosmetic procedures, breeding/pregnancy costs, and experimental treatments.",
      "**Everyday items:** food, supplements, and grooming (except prescription diets when explicitly covered)."
    ],
    images: PetGallery_v01
  }
];
